import Page from '../../containers/page/page.js';
import React, {Component} from 'react';
import type {TranslateType, ReduxStatusType} from '../../types.js';
import styles from '../ResourcesModule/ResourcesModule.module.css';
import stylesB from '../Resources/Resources.module.css';
import stylesC from "../Courses/Courses.module.css";
import translate from "../../config/text";
import doc from '../Resources/assets/file icons/doc.svg'
import docx from '../Resources/assets/file icons/docx.svg'
import gif from '../Resources/assets/file icons/gif.svg'
import jpg from '../Resources/assets/file icons/jpg.svg'
import pdf from '../Resources/assets/file icons/pdf.svg'
import png from '../Resources/assets/file icons/png.svg'
import ppt from '../Resources/assets/file icons/ppt.svg'
import pptx from '../Resources/assets/file icons/pptx.svg'
import txt from '../Resources/assets/file icons/txt.svg'
import xls from '../Resources/assets/file icons/xls.svg'
import zip from '../Resources/assets/file icons/zip.svg'
import file from '../Resources/assets/file icons/file.svg'
import { Link } from 'react-router-dom'

type PropsType = {
    status: ReduxStatusType
};

const Tags = (props) => {
    return (
        <div className={styles.singleTag}>
            <h1>{props.title}</h1>
            {
                props.resource.map(tag => {
                    return <div className={stylesB.singleTag}><Link
                        name={tag.title}
                        to={{
                            pathname: `/resources`,
                            state: { tid: tag.tid }
                        }}
                        className={stylesB.tagLink}
                        key={tag.tid}
                    >{tag.title}</Link>
                    </div>})
            }
        </div>
    )
}

const Aside = (props) => {
    return(
        <div className={styles.tagWrapper}>
            <Tags
                title='tags'
                resource={props.resource.tags}
            />
            <Tags
                title='types'
                resource={props.resource.types}
            />
            <Tags
                title='related to'
                resource={props.resource.related_to}
            />
        </div>

    )
}

const Header = (props) => {
    const timestamp = props.resource.created.timestamp;

    function addZero(num) {
        return ("0"+num).slice(-2);
    }

    function created(timestamp){
        var a = new Date(timestamp * 1000);
        var year = a.getFullYear();
        var month = a.getMonth();
        var date = a.getDate();
        var time = year + '-' + addZero(month) + '-' + addZero(date);
        return time;
    }

    return(
        <div className={`${stylesC.coursesPresentation} ${styles.resourcePresentation}`}>
            <p className={`${stylesC.welcomeText} fontTisa`}>{props.resource.title}</p>
            <p className={`${styles.presentationText} fontTisa`}>{created(timestamp)}</p>
        </div>
    )
}

const ArticleBody = (props) => {
    return(
        <div className={styles.resourceContent}>
            <div className={styles.resourceTeaser} dangerouslySetInnerHTML={ { __html: props.resource.body } }></div>
        </div>
    )
}

const Resources = (props) => {
    return(
        <div className={styles.resourceAttachments}>
            <h3>{props.t('attachments')}</h3>
            <div className={styles.attachntsWrapper}>
                {
                    props.resource.attachments.map(attachment => {
                        return (
                            <div className={styles.attach}>
                                <a className={styles.attachmentLink} href={attachment.url}>
                                    <div className={styles.attachmentIcon}><img src={props.icon(attachment.type)} alt=""/></div>
                                    <div className={styles.attachmentTitle}>filename/description:</div>

                                    <div className={`${styles.attachmentValue} ${styles.description}`}>{attachment.description !== '' ? attachment.description : attachment.filename}</div>
                                </a>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}


export class ResourcesModule extends Component<PropsType> {
    t: TranslateType
    constructor(props: PropsType) {
        super(props);
        this.state = {
            match: {
                tagName: ''
            }
        }
        this.t = translate(this.props.language);
    }

    componentDidMount(){
        this.props.fetchDataWithRedux();
        window.scrollTo(0, 0);
    }

    render() {
        const resourceId = this.props.route.match.params.resourceId;
        const resource = this.props.data.find(x => x.id === resourceId);

        const icon = (attachType) => {
            let split = attachType.split('/');
            let splitVal = split[1];

            switch (splitVal) {
                case 'msword':
                    return doc;
                case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
                    return docx;
                case 'gif':
                    return gif;
                case 'jpg':
                case 'jpeg':
                    return jpg;
                case 'pdf':
                    return pdf;
                case 'png':
                    return png;
                case 'vnd.ms-powerpoint':
                    return ppt;
                case 'vnd.openxmlformats-officedocument.presentationml.presentation':
                    return pptx;
                case 'plain':
                    return txt;
                case 'xls':
                case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                    return xls;
                case 'zip':
                    return zip;
                default:
                    return file
            }
        }



        return (
            <Page>
                <Header resource={resource}/>
                <div className={styles.contentWrapper}>
                    <Aside resource={resource}/>
                    <div className={styles.articleContent}>
                        <ArticleBody resource={resource} />
                        {
                            resource.attachments && resource.attachments.length !== 0 ?
                                <Resources
                                    t={this.t}
                                    icon={icon}
                                    resource={resource}
                                />
                                :
                                null
                        }
                    </div>
                </div>
            </Page>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ResourcesModule/ResourcesModule.js